import {
  externalUrlHidProductNameMatches,
  getSupportedDevicesSync,
  normalizeDeviceBrand,
} from "@eweadn-qiankun/shared-utils";

const LIST_KEYS = ["keyboard", "mouse", "earphone"] as const;

export function resolveDeviceBrandFromRow(
  row: Record<string, unknown>
): string {
  return normalizeDeviceBrand(row.brand) ?? "eweadn";
}

/** 不按当前 Hub 品牌过滤，用于异品牌识别 */
export function findSupportedDeviceRowUnfiltered(
  vendorId: number,
  productId: number,
  hidProductName?: string
): Record<string, unknown> | undefined {
  const matches: Record<string, unknown>[] = [];
  for (const listKey of LIST_KEYS) {
    const list = (getSupportedDevicesSync()[listKey] ?? []) as Record<
      string,
      unknown
    >[];
    for (const row of list) {
      if (row.vendorId === vendorId && row.productId === productId) {
        matches.push(row);
      }
    }
  }
  if (matches.length === 0) return undefined;
  if (matches.length === 1) return matches[0];
  const byName = matches.filter((row) =>
    externalUrlHidProductNameMatches(hidProductName, row as never)
  );
  if (byName.length >= 1) return byName[0];
  return matches[0];
}

export function deviceDisplayLabel(row: Record<string, unknown>): string {
  const name =
    (row.displayname as string) ||
    (row.productName as string) ||
    (row.name as string);
  return typeof name === "string" && name.trim() ? name.trim() : "设备";
}
